<template>

<core-panel>

	<template v-slot:head>

		<h1>Winners & Losers</h1>

		<p>The win rates of those played with.</p>

	</template>

	<template v-slot:body>

		<app-user type="player" :item="item" v-for="(item, index) in list" :key="index" :subtext="item.plays + ' play' + ((item.plays > 1) ? 's' : '')" :count-percent="true" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'wins',
			list: []
		}

	},

	methods: {

		response: function(json) {

			this.list = json.wins.list

		}

	}

}

</script>